<template>
    <div class="container">
        <div class="heading">
            Choose your withdrawal option
        </div>
        <v-radio-group v-model="selectedOption">
            <v-radio value="full" :ripple="false">
                <template v-slot:label>
                    <div>
                        <div class="option">Full Withdrawal</div>
                        <div class="subOption">Withdraw entire eligible amount.</div>
                    </div>
                </template>
            </v-radio>
            <v-radio value="partial" :ripple="false" v-if="checkPartialEligibility">
                <template v-slot:label>
                    <div>
                        <div class="option">Partial Withdrawal</div>
                        <div class="subOption">Choose a withdrawal amount on the next page.</div>
                    </div>
                </template>
            </v-radio>
            <v-radio value="unallocated" :ripple="false" v-if="checkUnallocatedEligibility">
                <template v-slot:label>
                    <div>
                        <div class="option">Withdraw Unallocated</div>
                        <div class="subOption">Withdraw your unallocated amount &#x20B9;{{ selectedPortfolio.unallocatedAmount | localeAmountPaisa }} </div>
                    </div>
                </template>
            </v-radio>
        </v-radio-group>

        <div style="padding-top: 30px; text-align: center;">
            <button class="withdrawButton" @click="confirmWithdrawalOption">
                Withdraw
            </button>
        </div>
    </div>
</template>

<script>
export default {
    name: 'WithdrawalOptions',
    props: {
        withdrawalAmount: {
            type: Number
        },
        unlockedAmount: {
            type: Number
        },
        selectedPortfolio: {
            type: Object
        }
    },
    data () {
        return {
            selectedOption: 'full'
        }
    },
    computed: {
        checkPartialEligibility () {
            if (this.withdrawalAmount >= 500000) {
                return true
            }
            return false
        },
        checkUnallocatedEligibility () {
            if (this.selectedPortfolio.unallocatedAmount >= 500000 && this.selectedPortfolio.unallocatedAmount <= this.unlockedAmount && this.selectedPortfolio.unallocatedAmount > 0) {
                return true
            } else {
                return false
            }
        }
    },
    methods: {
        confirmWithdrawalOption () {
            this.$emit('confirmWithdrawalOption', this.selectedOption)
        }
    }
}
</script>

<style lang="scss" scoped>
    @media (max-width: 480px) {
        .heading {
            margin: 0px !important;
        }
    }
    .heading {
        font-weight: 500;
        font-size: 21px;
        line-height: 25px;
        color: #232323;
        margin: 48px 0px 0px;
    }

    .option {
        font-size: 14px;
        color: #232323;
    }

    .subOption {
        font-weight: 400;
        font-size: 12px;
        color: #8C8C8C;
    }

    button {
        padding: 11px 24px;
        border-radius: 6px;
        letter-spacing: 0.005em;
        font-size: 14px;
        line-height: 150%;
        font-weight: 600;
        width: 70%;

    }

    .withdrawButton {
        background: #002FA7;
        color: #FFFFFF;
    }

    .v-radio {
        margin: 16px 0px;
    }

    .v-icon.v-icon {
        font-size: 20px;
    }

    .v-input--selection-controls__input:hover .v-input--selection-controls__ripple::before {
        background: unset
    }
</style>
